import { ReactNode } from 'react';
import styles from './CleanCard.module.scss';

interface ICleanCardTitle {
  children: ReactNode;
}

export function CleanCardTitle({ children }: ICleanCardTitle) {
  return <h3 className={styles.clear_card__item_title}>{children}</h3>;
}
